import { useTranslation } from 'react-i18next';
import IncrementNumberInput from '@/components/IncrementNumberInput';

function ExtraBed({ extraBedsTotal, onChange, value }) {
    const { t } = useTranslation();

    const handleChange = (val) => {
        onChange(val);
    };

    return (
        <div className="extra-bed">
            <div className="extra-bed-title">{t('Extra Bed')}</div>
            <IncrementNumberInput
                max={extraBedsTotal}
                hasInputBorder={false}
                onChange={handleChange}
                defaultCount={value}
            />
        </div>
    );
}

export default ExtraBed;
